/**
 * Default analytics reports (single source of truth).
 * Used by AnalyticsHub under Analytics > Reports and by BuntuDashboard.
 */

export interface DefaultReportItem {
  id: string;
  reportId: string;
  name: string;
  description: string;
}

export const DEFAULT_ANALYTICS_REPORTS: DefaultReportItem[] = [
  { id: 'report-device-summary', reportId: 'device-summary', name: 'Device Summary', description: 'Overview of all devices with key metrics and status information' },
  { id: 'report-compliance-status', reportId: 'compliance-status', name: 'Compliance Status', description: 'Device compliance status across all policies and baselines' },
  { id: 'report-platform-distribution', reportId: 'platform-distribution', name: 'Platform Distribution', description: 'Distribution of devices across different platforms and operating systems' },
  { id: 'report-security-alerts', reportId: 'security-alerts', name: 'Security Alerts', description: 'Security alerts and incidents across the device fleet' },
  { id: 'report-deployment-status', reportId: 'deployment-status', name: 'Deployment Status', description: 'Status of application and policy deployments' },
  { id: 'report-hardware-inventory', reportId: 'hardware-inventory', name: 'Hardware Inventory', description: 'Live hardware inventory snapshots across all managed devices' },
  { id: 'report-software-inventory', reportId: 'software-inventory', name: 'Software Inventory', description: 'Installed applications with footprint, publisher, and metering state' },
  { id: 'report-software-metering', reportId: 'software-metering', name: 'Software Metering', description: 'Usage analytics for metered applications per device' },
  { id: 'report-activity-tracking', reportId: 'activity-tracking', name: 'Activity Tracking', description: 'User activity tracking with application usage, URLs, and productivity metrics' },
];
